import axios from 'axios';
import { getToken, setToken } from './auth';
import config from "../config";
import store from '../store';
const refreshProgressWildcards = ['/shippments', '/payments', '/websites'];
import Vue from 'vue';
const service = axios.create({
    baseURL: config.config.base_url,
    timeout: 1200000, // Request timeout
    withCredentials: true
});

// Request intercepter
service.interceptors.request.use(
    config => {
        config.onUploadProgress = (event) => {
            if(event.total != event.loaded){
                Vue.prototype.$eventBus.$emit('uploadingProgress', Math.round((event.loaded * 100)/ event.total));
            }
        }
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + getToken(); // Set JWT token
        }
        config.headers['admin'] = 1;
        if(store.getters.activeWebsite){
            config.headers['website'] = store.getters.activeWebsite.id;
        }
        return config;
    },
    error => {
        // Do something with request error
        Promise.reject(error);
    }
);

// response pre-processing
service.interceptors.response.use(
    response => {
        Vue.prototype.$eventBus.$emit('stopUploading', true);
        if(response.headers['content-type'] == 'text/csv; charset=UTF-8'){
            var name = response.headers['content-disposition'];
            if(name){
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(name);
                if (matches != null && matches[1]) {
                    name = matches[1].replace(/['"]/g, '');
                }
            }else{
                name = 'default.csv';
            }
            var pom = document.createElement('a');
            var csvContent=response.data; //here we load our csv data
            var blob = new Blob([csvContent],{type: 'text/csv;charset=utf-8;'});
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', name);
            pom.click();
        }
        if(response.config && (response.config.method == 'post' || response.config.method == 'put' || response.config.method == 'delete')){
            var check = false;
            refreshProgressWildcards.forEach((item) => {
                if(response.request.responseURL.toLowerCase().includes(item.toLowerCase())){
                    check = true;
                }
            })
            if(check) store.dispatch('app/getProgress', true);
        }
        if (response.headers.authorization) {
            setToken(response.headers.authorization);
            response.data.token = response.headers.authorization;
        }
        return response.data;
    },
    error => {
        Vue.prototype.$eventBus.$emit('stopUploading', false);
        if(error.response && error.response.status == 413){
            store.commit('app/ADD_ERROR', {text: 'Wysłany obrazek jest prawdopodobnie zbyt duży', cancelable: true});
        }
        let message = error.message;
        if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
        }

        return Promise.reject(error);
    },
);

export default service;
